import { Box } from '@mui/material'
import { ShowDialogProps } from 'src/show-dialog'
import GlobalCalendarContent from './GlobalCalendarContent'

interface GlobalCalendarDialogProps extends ShowDialogProps {
  customerId: EntityId
}

// Rendered inside the shared dialog chrome (title + close) provided by showDialog.
const GlobalCalendarDialog = ({ customerId, pop }: GlobalCalendarDialogProps) => {
  return (
    <Box sx={{ p: { xs: 1, md: 2 }, width: '100%' }}>
      <GlobalCalendarContent customerId={customerId} onNavigate={() => pop()} />
    </Box>
  )
}

export default GlobalCalendarDialog
